import { FunctionComponent } from "react";
import CreateLoginForm from "./loginForm";

const Login: FunctionComponent = () => {
  return <CreateLoginForm />;
};

export default Login;
